import { tabsClasses } from '@mui/material/Tabs';

const styles = {
  tabs: {
    [`&.${tabsClasses.root}`]: {
      [`& .${tabsClasses.indicator}`]: {
        height: '5.5px',
      },
    },
  },
};

export default styles;
